<template>
  <modal
    :show.sync="isActiveLocal"
    centered
    header-classes="bg-primary items-center rounded-none text-lg uppercase font-bold"
    modal-content-classes="cust-medi-popup cust-overflow-y-grey"
    hide-footer
    class="overflow-y-hidden"
  >
    <div class="flex justify-between pb-8">
      <div class="my-auto">
        <p class="font-medium text-2xl text-black">
          {{ selectedMedical.text }}
        </p>
      </div>
      <img
        src="../../../assets/images/cross.png"
        class="h-8 w-8 cursor-pointer"
        alt="cross"
        @click="isActiveLocal = false"
      />
    </div>
    <div class="">
      {{ selectedMedical.description }}
      <p
        class="mt-2 text-primary cursor-pointer"
        v-if="selectedMedical.text === 'Cancer'"
        @click="handleClick('medical_cancer')"
      >
        Know More
      </p>
      <p
        class="mt-2 text-primary cursor-pointer"
        v-if="selectedMedical.text === 'Palliative Care'"
        @click="handleClick('medical_palliative')"
      >
        Know More
      </p>
      <p
        class="mt-2 text-primary cursor-pointer"
        v-if="selectedMedical.text === 'Dementia'"
        @click="handleClick('medical_dementia')"
      >
        Know More
      </p>
      <p
        class="mt-2 text-primary cursor-pointer"
        v-if="selectedMedical.text === 'Neurological Disorders'"
        @click="handleClick('medical_neurologicaldisorders')"
      >
        Know More
      </p>
      <!-- <a
        target="_blank"
        class="cursor-pointer text-primary hover:underline"
        :href="selectedMedical.hlink"
        >{{ selectedMedical.sayhere }}</a
      > -->
    </div>
    <template slot="footer"> <div></div> </template>
  </modal>
</template>

<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    selectedMedical: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    isActiveLocal: {
      get() {
        return this.isActive;
      },
      set(val) {
        if (!val) {
          this.closeModal();
        }
      },
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
